import { Injectable } from '@angular/core';
import * as downloadJs from 'src/assets/lib/download.js';
import { UtilService } from '../utils/util.service';

@Injectable({ providedIn: 'root' })
export class DownloadFileService {
    constructor(
        public utilService: UtilService
    ) { }
    /*
     * 使用download.js 强制浏览器下载图片、视频等文件
     * @param {any} url url链接地址
     * @param {any} strFileName 文件名
     * @param {any} strMimeType 文件类型
     *
     * 食用 this.downloadFile(pdfSrc, 'xxx.pdf');
     */
    downloadFile(url, strFileName): any {
        const xmlHttp = new XMLHttpRequest();
        // 1.如果实例化成功，就调用open（）方法：
        if (xmlHttp != null) {
            xmlHttp.open('get', url, true);
            xmlHttp.responseType = 'blob'; // 关键
            xmlHttp.send();
            xmlHttp.onreadystatechange = () => {
                if (xmlHttp.readyState === 4) { // 4表示执行完成
                    if (xmlHttp.status === 200) { // 200表示执行成功
                        downloadJs(xmlHttp.response, strFileName, this.utilService.getFileType(strFileName));
                    }
                }
            }; // 设置回调函数
        }
    }
}
